import $ from "jquery";
import _ from "lodash";
import { headersConfigData } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { store } from "redux/store";
import { mapHelpers } from "./mapHelpers";
import { vc } from "./visageConstants";

export const loadPicture = (
  context,
  src,
  greenImageSize,
  hole,
  canvasElement,
  greensDescriptions
) => {
  let imageCounter = 0;
  let failedImagesCounter = 0;
  const imageObj = new Image();
  const flag = new Image();
  const { siteSettingsData } = store.getState().commonReducers;
  context.clearRect(0, 0, greenImageSize, greenImageSize);
  context.fillStyle = "rgb(34, 85, 32)";
  context.fillRect(0, 0, greenImageSize, greenImageSize);

  // Creating Round Rectangle That Contains Flag
  let roundRect = function (ctx, x, y, width, height, radius, fill, stroke) {
    if (typeof stroke == "undefined") {
      stroke = true;
    }
    if (typeof radius === "undefined") {
      radius = 5;
    }
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width - radius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    ctx.lineTo(x + width, y + height - radius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    ctx.lineTo(x + radius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
    if (stroke) {
      ctx.stroke();
    }
    if (fill) {
      ctx.fill();
    }
  };

  // Check For Image Loading Errors -- Uncomment Later
  let checkForImageLoadingErrors = function () {
    if (imageCounter >= greensDescriptions?.ApproachViews.length) {
      // TODO -- In Old code they are using "xlate" for "internationalization / localization"
      if (failedImagesCounter > 0) alert("Problem in loading images");
    }
  };

  // Drawing Flag inside of Rectangle box
  flag.onload = function () {
    context.drawImage(flag, 5, 0);
  };

  // Logic while image is loading
  imageObj.onload = function () {
    // console.log("hole",hole)

    // TODO -- Atomatically Set Image Flag Colors -- Uncomment Later Cause Require Course from API
    var dcCrs =
      siteSettingsData &&
      Object.keys(siteSettingsData).length !== 0 &&
      siteSettingsData?.Courses &&
      siteSettingsData?.Courses.length !== 0
        ? _.find(siteSettingsData?.Courses, { Number: hole.CourseNumber })
        : -13527975;
 
    var crsColor =
      !_.isNull(dcCrs.ColorRGB) && !_.isUndefined(dcCrs.ColorRGB)
        ? mapHelpers.convIntToRGB(dcCrs.ColorRGB)
        : vc.getDefaultCourseColors(hole?.Course);
    var crsTxtColor = mapHelpers.getTextColorBasedOnRGB(crsColor);

    context.setTransform(
      hole.viewToGreen.m[0],
      hole.viewToGreen.m[1],
      hole.viewToGreen.m[2],
      hole.viewToGreen.m[3],
      hole.viewToGreen.m[4],
      hole.viewToGreen.m[5]
    );
    context.drawImage(imageObj, 0, 0);
    imageCounter++;

    hole.greenHeight = imageObj.height;
    hole.greenWidth = imageObj.width;

    // Reset transform before drawing the hole number and pin flag.
    context.setTransform(1, 0, 0, 1, 0, 0);
    context.fillStyle = "#" + crsColor;
    context.strokeStyle = "#" + crsTxtColor;
    roundRect(context, 1, 1, 44, 22, 5, true, true);
    context.font = "18px sans-serif";
    context.fillStyle = "#" + crsTxtColor;
    context.fillText(hole?.Hole, 24, 18);

    flag.src = require("../../../assets/Content/images/pin_" +
      (crsTxtColor === "FFFFFF" ? "wht" : "blk") +
      ".png");
    // Check to display message.
    checkForImageLoadingErrors();
  };

  // Handler for errors loading the green image.
  imageObj.onerror = function () {
    failedImagesCounter++;
    imageCounter++;
    var errorImage = new Image();
    errorImage.onload = function () {
      context.setTransform(1, 0, 0, 1, 0, 0);
      context.drawImage(errorImage, 0, 0, greenImageSize, greenImageSize);
    };
    errorImage.src = require("../../../assets/Content/images/notfound.jpg");

    // Check to display message.
    checkForImageLoadingErrors();

    // Hide the svg element
    $(canvasElement).siblings().css({ display: "none" });
  };

  const imgSrc = src;
  if (imgSrc) {
    const options = {
      headers: headersConfigData(),
    };
    fetch(imgSrc, options)
      .then((res) => res.blob())
      .then((blob) => {
        if (blob?.type !== "text/plain") {
          imageObj.src = URL.createObjectURL(blob);
        }
      });
  }
};
